export const initialStep = () => ({
  step: 1,
  display: true,
  status: "pending",
  text: "Salvando a proposta...",
  success_text: "Proposta n° arg criada com sucesso.",
  error_text: "Não foi possivel salvar a proposta.",
  details: null,
});

export const creditStep = () => ({
  step: 2,
  display: false,
  status: "pending",
  text: "Aprovação automática de cŕedito...",
  success_text: "Crédito aprovado automaticamente.",
  error_text: "Aprovação automática de crédito.",
  details: {
    recusado: "Proposta recusada pela análise automática de crédito.",
    corretor:
    "Prezado Corretor, o tomador passará por análise de crédito manual, favor prosseguir com anexo de documentação solicitada. Em breve retornamos com as condições de limites e taxas.",
    seguradora:
    "Prezado Corretor, o tomador passará por análise de crédito manual. Em breve retornamos com as condições de limites e taxas.",
  },
});

export const subscriptionStep = () => ({
  step: 3,
  display: false,
  status: "pending",
  text: "Aprovação automática de subscrição...",
  success_text: "Subscrição aprovada automaticamente.",
  error_text: "Aprovação automática de subscrição.",
  details: {
    recusado: "Proposta recusada pela análise automática de subscrição.",
    corretor:
    "Necessário fornecer documentação complementar do Risco a ser garantido, e a proposta será direcionada para análise de subscrição.",
    seguradora: "A proposta será direcionada para análise de subscrição.",
  },
});

export const reseguroStep = () => ({
  step: 4,
  display: false,
  status: "pending",
  text: "Aprovação automática de resseguro...",
  success_text: "Resseguro aprovado automaticamente.",
  error_text: "Aprovação automática de resseguro.",
  details: {
    recusado: "Proposta recusada pela análise automática de resseguro.",
    corretor:
    "Necessário fornecer documentação complementar do Risco a ser garantido, e a proposta será direcionada para análise de resseguro.",
    seguradora: "A proposta será direcionada para análise de resseguro.",
  },
});

export const policyAutoApprovalStep = () => ([
  initialStep(),
  creditStep(),
  subscriptionStep(),
  reseguroStep()
]);



// WEBPACK FOOTER //
// ./src/libs/autoApprovalProcessSteps.js